import { Loader2, Map, Satellite, X } from 'lucide-react'
import React, { FC } from 'react'
import styled, { keyframes } from 'styled-components'

import { tooltipStyles } from './styles'

export type MapStyle = 'street' | 'satellite' | 'off'

const MapStyleHotbarContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0px;
`

const MapStyleButton = styled.div<{ $selected: boolean }>`
  ${tooltipStyles}
  cursor: pointer;
  background-color: ${({ $selected }) =>
    $selected ? 'rgba(80, 80, 100, 0.9)' : 'rgba(20, 20, 30, 0.8)'};
  padding: 8px 12px;
  min-width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;

  &:first-child {
    border-radius: 6px 0 0 6px;
  }

  &:last-child {
    border-radius: 0 6px 6px 0;
  }

  &:hover {
    background-color: ${({ $selected }) =>
      $selected ? 'rgba(80, 80, 100, 1)' : 'rgba(40, 40, 50, 0.9)'};
  }
`

const MapStyleIconWrapper = styled.div`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;

  svg {
    animation: ${spin} 1s linear infinite;
  }
`

interface MapStyleHotbarProps {
  mapStyle: MapStyle
  onStyleChange: (style: MapStyle) => void
  loadingStyle?: MapStyle | null
}

export const MapStyleHotbar: FC<MapStyleHotbarProps> = ({
  mapStyle,
  onStyleChange,
  loadingStyle,
}) => {
  return (
    <MapStyleHotbarContainer>
      <MapStyleButton
        $selected={mapStyle === 'street'}
        onClick={() => onStyleChange('street')}
        data-tooltip='Street map'>
        <MapStyleIconWrapper>
          <Map size={18} />
        </MapStyleIconWrapper>
        {loadingStyle === 'street' && (
          <LoadingOverlay>
            <Loader2 size={16} />
          </LoadingOverlay>
        )}
      </MapStyleButton>
      <MapStyleButton
        $selected={mapStyle === 'satellite'}
        onClick={() => onStyleChange('satellite')}
        data-tooltip='Satellite imagery'>
        <MapStyleIconWrapper>
          <Satellite size={18} />
        </MapStyleIconWrapper>
        {loadingStyle === 'satellite' && (
          <LoadingOverlay>
            <Loader2 size={16} />
          </LoadingOverlay>
        )}
      </MapStyleButton>
      <MapStyleButton
        $selected={mapStyle === 'off'}
        onClick={() => onStyleChange('off')}
        data-tooltip='Hide map'>
        <MapStyleIconWrapper>
          <X size={18} />
        </MapStyleIconWrapper>
      </MapStyleButton>
    </MapStyleHotbarContainer>
  )
}
